import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash, faRepeat } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';

const ItemWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 3px;
  border-left: 4px #a3a4a5 solid;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

  ${(props) => props.status === 'active' && `border-left-color: #00A89C;`}

  span {
    color: #a3a4a5;
    font-size: 10px;
  }
`;

const IconButton = styled(FontAwesomeIcon)`
  margin-left: 10px;
  ${(props) => props.disable === 'true' && `opacity: 0.2;`}
`;

const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

function NotificationItem({ notification, onPreview, onDelete, onRestore, loading }) {
  const formatDate = (dateString) => moment(dateString).format('DD/MM/YYYY HH:mm');

  return (
    <ItemWrapper status={!notification.deletadaEm && 'active'}>
      <FlexBox>
        <h4>{notification.titulo}</h4>
        <div>
          <FontAwesomeIcon
            icon={faEye}
            size="sm"
            title="preview"
            style={{ cursor: 'pointer' }}
            onClick={() => onPreview(notification)}
          />
          {notification.deletadaEm ? (
            <IconButton
              disable={loading.toString()}
              icon={faRepeat}
              size="sm"
              title="retornar"
              style={{ cursor: 'pointer' }}
              onClick={async () => {
                if (loading) return;
                await onRestore(notification.id);
              }}
            />
          ) : (
            <IconButton
              disable={loading.toString()}
              icon={faTrash}
              size="sm"
              color="red"
              title="remover"
              style={{ cursor: 'pointer' }}
              onClick={async () => {
                if (loading) return;
                await onDelete(notification.id);
              }}
            />
          )}
        </div>
      </FlexBox>
      <div>
        <span>Para: {notification.usuarioTipo}</span>
        <span>{formatDate(notification.criadaEm)}</span>
      </div>
    </ItemWrapper>
  );
}

NotificationItem.propTypes = {
  loading: PropTypes.bool.isRequired,
  notification: PropTypes.shape().isRequired,
  onPreview: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
};

export default NotificationItem;
